import { Spinner } from '../spinner';

export interface LoadingProps {
  fullscreen?: boolean;
  cover?: boolean;
  showBackground?: boolean;
}

export function Loading({ fullscreen, cover, showBackground }: LoadingProps) {
  return (
    <div
      className={`
      ${fullscreen ? 'top-0 left-0 fixed h-screen w-screen z-50' : ''}
      ${cover ? 'top-0 left-0 fixed h-full w-full z-50' : ''}
      flex items-center justify-center text-center
      ${showBackground ? ' bg-black/30' : ''}
    `}
    >
      <div
        className={`
        ${fullscreen ? 'top-0 left-0 fixed h-screen w-screen z-50' : ''}
        ${cover ? 'top-0 left-0 fixed h-full w-full z-50' : ''}
        flex items-center justify-center text-center
        ${showBackground ? 'bg-primary-lighten-60 opacity-20' : ''}
      `}
      />
      <Spinner />
    </div>
  );
}

export default Loading;
